import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useContext, useState } from 'react';
import { Text, View, StyleSheet } from 'react-native';
import { brand } from '../../../../styles/rn';
import Input from '../../../Input/rn';
import { FormContext, ModeType, ValidateStatusType } from '..';
import { lengthValidator } from '../config';
var styles = StyleSheet.create({
  webformItemEditWrapper: {
    paddingTop: 16,
    paddingLeft: 12,
    paddingRight: 12
  },
  inputErrMsg: {
    color: brand
  },
  inputErrMsgWithPadding: {
    color: brand,
    paddingLeft: 12
  }
});
export default (function (props) {
  var mode = props.mode,
    value = props.value;
  var _React$useState = React.useState(undefined),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    errMsg = _React$useState2[0],
    setErrMsg = _React$useState2[1];
  var formContext = useContext(FormContext);
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    text = _useState2[0],
    setText = _useState2[1];
  var _useState3 = useState(props.region || 'sg'),
    _useState4 = _slicedToArray(_useState3, 2),
    region = _useState4[0],
    setRegion = _useState4[1];
  useEffect(function () {
    if (!value) {
      setText('');
    } else if (typeof value === 'string') {
      var _props$onChange;
      (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, [props.region, value]);
    } else {
      var v = value[1];
      setText(v);
    }
    var region = (value !== null && value !== void 0 && value[0] ? value[0] : props.region || 'sg').toLowerCase();
    setRegion(region);
  }, [value, props.region]);
  useEffect(function () {
    if ((formContext === null || formContext === void 0 ? void 0 : formContext.validateStatus) === ValidateStatusType.Validating) {
      var _formContext$handleFo;
      var res = handleValidate(text);
      formContext === null || formContext === void 0 ? void 0 : (_formContext$handleFo = formContext.handleFormItemValidate) === null || _formContext$handleFo === void 0 ? void 0 : _formContext$handleFo.call(formContext, _defineProperty({}, props.name, res ? res : ValidateStatusType.Success));
    }
  }, [text, formContext === null || formContext === void 0 ? void 0 : formContext.validateStatus]);
  var handleValidate = function handleValidate(value) {
    if (props.validator) {
      var msg = props.validator(value);
      setErrMsg(msg);
      return msg;
    } else if (props.required) {
      if (!value) {
        setErrMsg('The Field is required');
        return 'The Field is required';
      } else if (lengthValidator(value, props)) {
        return lengthValidator(value, props);
      }
      setErrMsg(undefined);
    }
  };
  var handleChange = function handleChange(value) {
    var _props$onChange2;
    setText(value);
    (_props$onChange2 = props.onChange) === null || _props$onChange2 === void 0 ? void 0 : _props$onChange2.call(props, [region, value]);
    handleValidate(value);
  };
  return /*#__PURE__*/React.createElement(View, null, [ModeType.Edit, ModeType.EditItem].includes(mode) ? /*#__PURE__*/React.createElement(View, {
    style: [ModeType.EditItem].includes(mode) ? styles.webformItemEditWrapper : {}
  }, /*#__PURE__*/React.createElement(Input, _extends({
    errMsg: errMsg
  }, props, {
    value: text,
    onChange: handleChange
  }))) : null, [ModeType.View, ModeType.Checking].includes(mode) ? /*#__PURE__*/React.createElement(Text, null, text) : null, !!errMsg ? /*#__PURE__*/React.createElement(Text, {
    style: mode === ModeType.Checking ? styles.inputErrMsg : styles.inputErrMsgWithPadding
  }, errMsg) : null);
});